import { GridCellProps } from '@progress/kendo-react-grid';
import { TextBoxChangeEvent } from '@progress/kendo-react-inputs';
import React, { useCallback } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import TextInput from 'src/components/TextInput';

const EditUomInput: React.ComponentType<GridCellProps> = (props) => {
  const { dataItem, field = '' } = props;
  const value = dataItem[field];
  const handleChange = useCallback(
    (e: TextBoxChangeEvent) => {
      props?.onChange?.({
        dataIndex: props.dataItem,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.value,
      });
    },
    [props]
  );

  return (
    <GridCellBase {...props}>
      <TextInput value={value} valid={!!value} onChange={handleChange} />
    </GridCellBase>
  );
};
export default EditUomInput;
